<template>
  <div class="type_two_number" :class="{ loading }">
    <div class="loading_spinner">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <ElTooltip :content="statusMessage">
      <div class="status" :class="status"></div>
    </ElTooltip>
    <div class="title">Баланс</div>
    <div class="value first">{{ values[0] }}</div>
    <div class="title first">
      {{ declOfNum(values[0], ["Рубль", "Рубля", "Рублей"]) }}
    </div>
    <div class="value second">{{ values[1] }}</div>
    <div class="title second">
      {{ declOfNum(values[1], ["Бонус", "Бонуса", "Бонусов"]) }}
    </div>
  </div>
</template>

<script>
let apiDriver = require("../../apiDriver").default;
let moment = require("moment");
import { Tooltip } from "element-ui";

export default {
  name: "system_balance",
  components: {
    [Tooltip.name]: Tooltip,
  },
  data: function () {
    return {
      loading: true,
      values: [0, 0],
      status: "",
      statusMessage: "",
    };
  },
  methods: {
    moment,
    declOfNum: function (number, titles) {
      var cases = [2, 0, 1, 1, 1, 2];
      return titles[
        number % 100 > 4 && number % 100 < 20
          ? 2
          : cases[number % 10 < 5 ? number % 10 : 5]
      ];
    },
    getData: async function () {
      this.loading = true;

      var balances = await apiDriver.transactions.available();
      console.log("balances", balances);
      this.values[0] = balances.real;
      this.values[1] = balances.bonus;

      if (balances.real + balances.bonus < 10) {
        this.status = "red";
        this.statusMessage = "Средства закончились";
      } else if (balances.real + balances.bonus < 1000) {
        this.status = "orange";
        this.statusMessage = "Скоро закончатся средства";
      } else {
        this.status = "green";
        this.statusMessage = "Средств достаточно";
      }

      this.loading = false;
    },
  },
  mounted: function () {
    this.getData();
  },
};
</script>